import {
  CircuitBoard,
  UserRoundCheck,
  Timer,
  HeartHandshake,
  Hourglass,
  ScrollText,
  Users,
} from "lucide-react";

const FEATURES = [
  {
    icon: CircuitBoard,
    title: "Modern Imaging Equipment",
    desc: "Latest sonography, doppler and digital X-ray systems for sharper, low-dose imaging.",
  },
  {
    icon: UserRoundCheck,
    title: "Experienced Radiologist",
    desc: "All studies are personally read and reported by a senior consultant radiologist.",
  },
  {
    icon: Timer,
    title: "Timely & Accurate Reports",
    desc: "Most reports are ready the same day — clear, concise and clinically helpful.",
  },
  {
    icon: HeartHandshake,
    title: "Comfortable Patient Experience",
    desc: "Calm rooms, polite staff and gentle handling — especially for expectant mothers.",
  },
  {
    icon: Hourglass,
    title: "Minimal Waiting Time",
    desc: "Time-slotted appointments mean less waiting and a smoother visit for everyone.",
  },
  {
    icon: ScrollText,
    title: "Clear Guidance for Patients",
    desc: "Every patient is briefed before and after the scan — no medical jargon, just clarity.",
  },
  {
    icon: Users,
    title: "Trusted by Families",
    desc: "Hundreds of families across Wagholi, Kesnand, Kharadi and Lohegaon trust Nidan.",
  },
];

export default function WhyNidan() {
  return (
    <section
      id="why-nidan"
      data-testid="why-nidan-section"
      className="py-20 lg:py-28 bg-[#f8fafc]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-[#0099CC]">
            Why Nidan
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
            Precision Diagnostics, <span className="text-[#0099CC]">Delivered with Compassion</span>
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {FEATURES.map((f, i) => (
            <div
              key={f.title}
              data-testid={`why-card-${i}`}
              className={`group rounded-2xl p-7 transition-all duration-300 ${
                i === 0
                  ? "bg-gradient-to-br from-[#00BFFF] to-[#0099CC] text-white lg:row-span-1 shadow-[0_18px_40px_rgba(0,153,204,0.25)]"
                  : "bg-white border border-slate-100 shadow-[0_4px_20px_rgba(15,23,42,0.03)] hover:shadow-[0_18px_40px_rgba(15,23,42,0.07)] hover:-translate-y-1"
              }`}
            >
              <div
                className={`w-12 h-12 rounded-2xl flex items-center justify-center mb-5 ${
                  i === 0 ? "bg-white/20 text-white" : "bg-[#00BFFF]/10 text-[#0099CC] group-hover:bg-[#00BFFF] group-hover:text-white"
                } transition-colors`}
              >
                <f.icon className="w-6 h-6" strokeWidth={2} />
              </div>
              <h3 className={`text-lg font-semibold ${i === 0 ? "text-white" : "text-slate-900"}`}>
                {f.title}
              </h3>
              <p
                className={`mt-2 text-sm leading-relaxed ${
                  i === 0 ? "text-white/90" : "text-slate-600"
                }`}
              >
                {f.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
